import {createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function getById(id, includes = []) {
    return makeRequest(createRequest('partner/' + id), prepareRequest({}, includes));
}